import React from "react";
import { Swapicon } from "./Swapicon";
import { LargeButton } from "./LargeButton";

interface Props {
  className?: string;
  namesAndLocation?: string;
  quote?: string;
  icon?: JSX.Element;
  videoUrl?: string;
}

export const Testimonial: React.FC<Props> = ({
  className = "",
  namesAndLocation = "- Name & Name, Location.",
  quote = '"Some text goes here. Some text goes here. Some text goes here. Some text goes here. Some text goes here."',
  icon = <Swapicon className="!relative !flex-1 !grow !h-[125px]" />,
  videoUrl,
}) => {
  return (
    <div className={`flex flex-col items-center justify-center px-[170px] py-20 relative ${className}`}>
      <div className="flex flex-col items-center justify-center gap-[70px] px-[143px] py-0 self-stretch w-full relative flex-[0_0_auto]">
        <div className="flex w-[135px] items-center justify-center gap-2.5 p-[5px] relative flex-[0_0_auto] bg-[var(--fy-greyish)] rounded-[500px]">
          {icon}
        </div>

        <div className="flex w-[615px] items-center justify-center gap-2.5 relative flex-[0_0_auto]">
          <p className="relative flex-1 mt-[-1.00px] [font-family:var(--testimonial-quote-font-family)] [font-size:var(--testimonial-quote-font-size)] [font-weight:var(--testimonial-quote-font-weight)] [font-style:var(--testimonial-quote-font-style)] text-[var(--fy-grey)] tracking-[var(--testimonial-quote-letter-spacing)] leading-[var(--testimonial-quote-line-height)] [text-transform:var(--testimonial-quote-text-transform)] text-center">
            {quote}
          </p>
        </div>

        <div className="inline-flex flex-col items-start relative flex-[0_0_auto]">
          <p className="relative self-stretch mt-[-1.00px] [font-family:var(--testimonial-name-location-font-family)] [font-size:var(--testimonial-name-location-font-size)] [font-weight:var(--testimonial-name-location-font-weight)] [font-style:var(--testimonial-name-location-font-style)] text-[var(--fy-grey)] tracking-[var(--testimonial-name-location-letter-spacing)] leading-[var(--testimonial-name-location-line-height)] [text-transform:var(--testimonial-name-location-text-transform)] text-center">
            {namesAndLocation}
          </p>
        </div>

        <LargeButton text="WATCH HIGHLIGHTS" videoUrl={videoUrl} />
      </div>
    </div>
  );
}; 